<template>
  <div class="box stat-box sub-duration-table">
    <div class="columns">
      <div class="column"><h3>נתוני אורך מנוי:</h3></div>
      <div class="column">
        <h5>מתחת ל14 ימים</h5>
        {{ under14.length }}
      </div>
      <div class="column">
        <h5>14 - 30 ימים</h5>
        {{ d14To30.length }}
      </div>
      <div class="column">
        <h5>30 - 60 ימים</h5>
        {{ d30To60.length }}
      </div>
      <div class="column">
        <h5>60 - 90 ימים</h5>
        {{ d60To90.length }}
      </div>
      <div class="column">
        <h5>90 - 180 ימים</h5>
        {{ d90To180.length }}
      </div>
      <div class="column">
        <h5>180 - 360 ימים</h5>
        {{ d180To360.length }}
      </div>
      <div class="column">
        <h5>מעל 360 ימים</h5>
        {{ over360.length }}
      </div>
    </div>
  </div>
</template>

<script>
import toDate from "date-fns/toDate";
import parseISO from "date-fns/parseISO";
import isAfter from "date-fns/isAfter";
import eachDayOfInterval from "date-fns/eachDayOfInterval";
import set from "date-fns/set";

export default {
  data() {
    return {
      under14: [],
      d14To30: [],
      d30To60: [],
      d60To90: [],
      d90To180: [],
      d180To360: [],
      over360: [],
    };
  },
  props: {
    joined: Array,
    renewed: Array,
  },
  computed: {
    subList() {
      return [...this.joined, ...this.renewed];
    },
  },
  watch: {
    subList() {
      this.under14 = [];
      this.d14To30 = [];
      this.d30To60 = [];
      this.d60To90 = [];
      this.d90To180 = [];
      this.d180To360 = [];
      this.over360 = [];
      this.subList.map((item) => this.getSubDuration(item));
    },
  },
  methods: {
    getSubDuration(item) {
      let end = set(toDate(new Date()), {
        hours: 12,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });

      if (item.cancel_date) {
        end = set(parseISO(item.cancel_date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        });
      }
      let start = set(parseISO(item.sub_date), {
        hours: 12,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });

      if (item.renew_date) {
        start = set(parseISO(item.renew_date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        });
      }

      if (isAfter(end, start)) {
        let days = eachDayOfInterval({ start: start, end: end });
        item.days = days.length;
        if (days.length < 15) {
          this.under14.push(item);
        }
        if (days.length > 14 && days.length < 31) {
          this.d14To30.push(item);
        }
        if (days.length > 30 && days.length < 61) {
          this.d30To60.push(item);
        }
        if (days.length > 60 && days.length < 91) {
          this.d60To90.push(item);
        }
        if (days.length > 90 && days.length < 181) {
          this.d90To180.push(item);
        }
        if (days.length > 180 && days.length < 361) {
          this.d180To360.push(item);
        }
        if (days.length > 360) {
          this.over360.push(item);
        }
      }
      return item;
    },
  },
  mounted() {
    this.subList.map((item) => this.getSubDuration(item));
  },
};
</script>

<style lang="scss">
.sub-duration-table {
  text-align: center;
  h5 {
    font-weight: bold;
  }
  .column {
    border: 0.5px solid;
  }
}
</style>
